import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropdown", "chevron", "currentSection", "link"]

  connect() {
    this.isOpen = false

    // Watch for toc-spy setting data-toc-active on links
    this.observer = new MutationObserver(() => this.updateCurrentSection())
    this.linkTargets.forEach((link) => {
      this.observer.observe(link, { attributes: true, attributeFilter: ["data-toc-active"] })
    })

    // Close dropdown when clicking outside
    this.boundClickOutside = this.clickOutside.bind(this)
    document.addEventListener("click", this.boundClickOutside)
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
    document.removeEventListener("click", this.boundClickOutside)
  }

  updateCurrentSection() {
    const activeLink = this.linkTargets.find((link) => link.dataset.tocActive === "true")
    if (activeLink && this.hasCurrentSectionTarget) {
      this.currentSectionTarget.textContent = activeLink.textContent
    }
  }

  toggle() {
    this.isOpen = !this.isOpen
    this.updateDropdownState()
  }

  select() {
    this.isOpen = false
    this.updateDropdownState()
  }

  clickOutside(event) {
    if (!this.element.contains(event.target) && this.isOpen) {
      this.isOpen = false
      this.updateDropdownState()
    }
  }

  updateDropdownState() {
    this.dropdownTarget.classList.toggle("hidden", !this.isOpen)
    this.chevronTarget.dataset.open = this.isOpen
  }
}
